export const formatNumber = (
  num: number | string | null | undefined
): string => {
  return num ? `${num.toLocaleString('en-US').replace(/,/g, ' ')}` : '0'
}
